// extracted by mini-css-extract-plugin
module.exports = {"power-independence-I":"I_power-independence-I__M96k3"};